module.exports = __webpack_public_path__ + "img/heading_uk.c3cf101d.svg";